import { fetchApi } from './client'

export interface DashboardStats {
  totalRuns: number
  successRate: number // Percentage 0-100
  activeJobs: number
  phenotypeCount: number
}

export interface HealthStatus {
  service: string
  status: 'healthy' | 'degraded' | 'down'
  message?: string
}

/**
 * Fetch dashboard statistics.
 *
 * Note: Backend may not have this endpoint yet - provide graceful fallback.
 * The endpoint should aggregate from Redis job store.
 */
export async function getStats(): Promise<DashboardStats> {
  try {
    return await fetchApi<DashboardStats>('/api/v1/stats')
  } catch {
    // Fallback if endpoint doesn't exist yet
    // Calculate from available data
    return {
      totalRuns: 0,
      successRate: 0,
      activeJobs: 0,
      phenotypeCount: 0,
    }
  }
}

/**
 * Fetch system health status.
 *
 * Maps to existing /health endpoint.
 */
export async function getHealth(): Promise<HealthStatus[]> {
  try {
    const response = await fetchApi<{
      redis?: { connected: boolean }
      s3?: { connected: boolean }
      api?: boolean
    }>('/health')

    // Transform to HealthStatus array
    return [
      {
        service: 'API',
        status: 'healthy',
        message: 'Server responding',
      },
      {
        service: 'Redis',
        status: response.redis?.connected ? 'healthy' : 'down',
        message: response.redis?.connected ? 'Connected' : 'Disconnected',
      },
      {
        service: 'S3',
        status: response.s3?.connected ? 'healthy' : 'down',
        message: response.s3?.connected ? 'Connected' : 'Disconnected',
      },
    ]
  } catch {
    return [
      { service: 'API', status: 'down', message: 'Server not responding' },
      { service: 'Redis', status: 'down', message: 'Unknown' },
      { service: 'S3', status: 'down', message: 'Unknown' },
    ]
  }
}
